// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';
import { ButtonLargeLayout } from './buttons/ButtonLargeLayout';

const raw = {
  width: 760,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: 'ce071f87-59e9-40fc-8924-a89646f79a41',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3849ba6b-5aef-4ab2-bd97-1ed60e0297b5',
      type: 'Layout',
      runtimeType: null,
      name: 'outOfLivesButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'ce071f87-59e9-40fc-8924-a89646f79a41',
      data: {
        color: 'yellow',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {}
    },
    {
      id: '4f4ac496-619c-4e74-994a-4ab0c23c40d5',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -100,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.3,
        y: 0.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Broken_Heart_Icon',
      parent: '3849ba6b-5aef-4ab2-bd97-1ed60e0297b5',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3c31adcb-8942-44c9-96f3-0611a0312200',
      type: 'Text',
      runtimeType: null,
      name: 'timerText',
      className: '',
      x: 33,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '00:00:00',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#e84302',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3849ba6b-5aef-4ab2-bd97-1ed60e0297b5',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class OutOfLivesButtonLayout {
  static raw = raw;
  root: Container;
  outOfLivesButton: ButtonLargeLayout & { data: typeof raw['list'][1]['data'] };
  timerText: Text;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      outOfLivesButton: typeof raw['list'][1];
      timerText: typeof raw['list'][3];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
